import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UiJsonViewerComponent } from '@ui';

@Component({
  selector: 'app-attachment-viewer-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    UiJsonViewerComponent,
  ],
  templateUrl: './attachment-viewer-dialog.component.html',
  styleUrls: ['./attachment-viewer-dialog.component.scss'],
})
export class AttachmentViewerDialogComponent implements OnInit {
  jsonData: any = null;
  isLoading = true;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<AttachmentViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string },
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.loadAttachment();
  }

  loadAttachment() {
    const input = this.data.url;

    // Check if input is a JSON string (starts with [ or {)
    if (input && (input.trim().startsWith('[') || input.trim().startsWith('{'))) {
      try {
        this.jsonData = JSON.parse(input);
        this.isLoading = false;
        return;
      } catch {
        this.error = 'Failed to parse attachment data';
        this.isLoading = false;
        return;
      }
    }

    // Otherwise, treat as URL and fetch
    this.http.get(input).subscribe({
      next: (data) => {
        this.jsonData = data;
        this.isLoading = false;
      },
      error: () => {
        this.error = 'Failed to load attachment';
        this.isLoading = false;
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
